module.exports = __webpack_public_path__ + "static/img/tab-service.0ae1f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tab-service.png
// module id = C8mg
// module chunks = 0